var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-input",
      class: {
        "date-input--disabled": _vm.disabled,
        "date-input--focused": _vm.focused,
        "date-input--error": _vm.error,
        "date-input--readonly": _vm.readonly,
      },
    },
    [
      _c(
        "div",
        { staticClass: "date-input__wrapper" },
        [
          _c("FormInput", {
            ref: "input",
            class: {
              "primary-input--focused": _vm.focused,
              "primary-input--error": _vm.error,
            },
            attrs: {
              id: _vm.id,
              name: _vm.name,
              label: _vm.label,
              "label-option": _vm.labelOption,
              placeholder: _vm.placeholder,
              icon: "date",
              required: _vm.required,
              disabled: _vm.disabled,
              readonly: "",
              error: _vm.error,
            },
            on: {
              input: _vm.onInput,
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              keyup: _vm.onKeyup,
              keydown: _vm.onKeydown,
            },
            model: {
              value: _vm.formattedDate,
              callback: function ($$v) {
                _vm.formattedDate = $$v
              },
              expression: "formattedDate",
            },
          }),
          _vm._v(" "),
          _vm.datePickerVisible && !_vm.readonly
            ? _c("FormInputDatePicker", {
                ref: "datepicker",
                staticClass: "date-input__date-picker",
                attrs: {
                  initialSelectedDate: _vm.value,
                  "min-date": _vm.minDate,
                  "max-date": _vm.maxDate,
                  isDateDisabled: _vm.isDateDisabled,
                },
                on: { change: _vm.datePickerChangeHandler },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hint
        ? _c("span", {
            staticClass: "form-input__hint | form-input-hint",
            domProps: { innerHTML: _vm._s(_vm.hint) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error && _vm.errorMessage
        ? _c("span", {
            staticClass: "form-input__error | form-input-error",
            domProps: { innerHTML: _vm._s(_vm.errorMessage) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.successMessage
        ? _c("span", {
            staticClass: "form-input__success | form-input-success",
            domProps: { innerHTML: _vm._s(_vm.successMessage) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }